import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { ApiError } from '../api/httpClient'
import { track } from '../analytics/track'
import { ErrorContext, type AppError } from './ErrorContext'

function toAppError(error: unknown): AppError {
  if (error instanceof ApiError) {
    return {
      status: error.status,
      message: error.message,
      path: error.path,
      timestamp: error.timestamp,
      fieldErrors: error.fieldErrors,
    }
  }
  if (error instanceof Error) {
    return { message: error.message }
  }
  return { message: 'Unbekannter Fehler' }
}

export function ErrorProvider({ children }: { children: ReactNode }) {
  const [error, setError] = useState<AppError | null>(null)

  const reportError = useCallback((err: unknown) => {
    console.error(err)
    const appError = toAppError(err)
    track('error', { message: appError.message, status: appError.status, path: appError.path })
    setError(appError)
  }, [])

  const clearError = useCallback(() => setError(null), [])

  const value = useMemo(() => ({ error, reportError, clearError }), [error, reportError, clearError])

  return <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>
}
